module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-voxi-02.8448b8ae.jpg";